import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@/config/gameConfig';
import { THEME } from '@/config/theme';
import { drawArcadeBackground } from '@/utils/arcadeBackground';
import { createButton } from '@/ui/buttons';

export interface KickedSceneData {
  remainingMs?: number;
  roomId?: string;
}

const BUTTON_SIZES = {
  primary: { width: 280, height: 60, fontSize: THEME.sizes.body },
};

export class KickedScene extends Phaser.Scene {
  constructor() {
    super({ key: 'KickedScene' });
  }

  create(): void {
    this.cameras.main.fadeIn(300, 5, 7, 22);
    drawArcadeBackground(this);

    const panel = this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, 600, 300, THEME.colors.backgroundLightHex, 0.9);
    panel.setStrokeStyle(3, THEME.colors.magentaHex);

    this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 60, 'REMOVED FROM LOBBY', {
      fontFamily: THEME.fonts.heading,
      fontSize: THEME.sizes.heading,
      color: THEME.colors.magenta,
    }).setOrigin(0.5);

    this.add.text(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'The host removed you from the lobby.', {
      fontFamily: THEME.fonts.body,
      fontSize: THEME.sizes.body,
      color: THEME.colors.textMuted,
    }).setOrigin(0.5);

    createButton(this, {
      x: GAME_WIDTH / 2,
      y: GAME_HEIGHT / 2 + 80,
      text: 'MAIN MENU',
      onClick: () => {
        this.scene.start('MenuScene');
      },
      style: 'primary',
      sizes: BUTTON_SIZES,
      buttonType: 'normal',
    });
  }
}
